import React  from "react";
import { Form, InputGroup } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import Button from 'react-bootstrap/Button';
import {
  COMPLIANCE_APPROVED,
  COMPLIANCE_NEW,
  COMPLIANCE_PENDING,
  COMPLIANCE_REJECTED,
  COUNTRY,
  INVESTOR_TYPE_COMPANY,
  INVESTOR_TYPE_INDIVIDUAL,
  base_url,
} from "../utilities";
import moment from "moment";
import { useRef,useEffect,useState } from 'react';
import { InputFieldKYC, TextAreaField } from "../BusinessFlow/Kycform";
import { TiDeleteOutline } from "react-icons/ti";
import Cookies from 'js-cookie';
import { decrypt } from "../utils";

export const InvestorSettingsIndividual = ({
    getDocuments, indivInvFormData,handleUpdateKyc,
  saveKYCBtn, rejectedInvDetails, statusFlag,
  masterInvestorData, investorDatauser,
  handleChange,handleChangeDownload,defaultvalue,
    download, handleSubmit,handleSavechanges, handleFieldChange, handleDeleteClick,handleSaveDraft,mergedDownloads,handleIsDataNull,others,
  handleChangeDownloadForOthers,handleDeleteClickOthers}) => {
  const [role_code,setRoleCode]=useState(Cookies.get("role_code"));
    const fileInputRef = useRef(null);
    useEffect(()=>{
      if(role_code){
        const decryptedValueData = decrypt(role_code)
        setRoleCode(decryptedValueData);
      }
    },[])
  return (
    <p>
      {masterInvestorData?.status === COMPLIANCE_REJECTED &&
        <div className="rejected_reason ms-2 m-3 mb-4 d-flex justify-content-between">
          <div>
            <span className="text-danger">Reason for Rejection :</span>
            <span> {masterInvestorData?.admin_notes}</span>
          </div>
        </div>
      }
      <h6 className="text-primary fw-bolder ">Account Identification:</h6>
      <div className="row gap-lg-3">

        <InputFieldKYC
          label={"Name of the Investor"}
          placeholder={investorDatauser?.investor_name}
          disabled={true}
        />
        <InputFieldKYC
          label={"Phone"}
          name={"phone"}
          placeholder={investorDatauser?.phone}
          disabled={true}
        />

        <InputFieldKYC
          label={"Email"}
          name="email"
          htmlFor={"email"}
          placeholder={investorDatauser?.email}
          disabled={true}
          onChange={(e) => handleFieldChange('email', e.target.value)}


        />
      </div>

      <div className="row gap-lg-3 mt-2">


        <div className="col-md settings_YOE ">
          <label htmlFor="country" className="form-label">
            <p className="">Gender <span style={{ color: "red" }}>*</span></p>
          </label>
          <select
            className="form-select dropdn_select_cls_settings  shadow-ben APNL_option_flds"
            aria-label="form-select example"
            id="gender"
            name="gender"
            htmlFor={"gender"}
            autoComplete="off"
              value={masterInvestorData && statusFlag=== COMPLIANCE_PENDING || statusFlag=== COMPLIANCE_APPROVED? masterInvestorData.gender: masterInvestorData && statusFlag=== COMPLIANCE_REJECTED ? rejectedInvDetails?.gender : indivInvFormData?.gender}
            onChange={(e) => handleFieldChange('gender', e.target.value)}
            disabled={statusFlag===COMPLIANCE_APPROVED}
          >
            <option selected={defaultvalue}>Select</option>

            {["Male", "Female", "Other"].map((gender) => {
              return (
                <option key={gender} value={gender}>
                  {gender}
                </option>
              );
            })}
          </select>
        </div>

        <InputFieldKYC
          label={"Country of Residence"}
          id="country"
          name="country"
          htmlFor={"country"}
          placeholder={investorDatauser?.country}
          disabled={true}
        />
        <InputFieldKYC
          label={"Nationality"}
          id="nationality"
          name="nationality"
          htmlFor={"nationality"}
          placeholder={investorDatauser?.nationality}
          disabled={true}
        />

      </div>

      <div className="row gap-lg-3 mt-2">
        <div className="pe-2">
          <p className="text_st mb-1 ">Address (as per address proof) <span style={{ color: "red" }}>*</span></p>
          <Form>
            <Form.Group
              className=" text_area_placeholder"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Control
                // disabled={rejectedFlag}
                size="sm"
                className="ANLtextarea "
                name="registered_address"
                as="textarea"
                rows={2}
                  value={masterInvestorData &&( statusFlag=== COMPLIANCE_PENDING || statusFlag=== COMPLIANCE_APPROVED) ? masterInvestorData.registered_address: masterInvestorData && statusFlag=== COMPLIANCE_REJECTED ? rejectedInvDetails?.registered_address : indivInvFormData?.registered_address}
                onChange={(e) => handleFieldChange('registered_address', e.target.value)}
                disabled={statusFlag===COMPLIANCE_APPROVED}
              />
            </Form.Group>
          </Form>
        </div>
      </div>


      <div className="row gap-lg-3 mt-2">
        <InputFieldKYC label={"Home Country Contact No."} type={"number"}
          placeholder={"Input phone number"}
          onChange={(e) => handleFieldChange('home_country_contact', e.target.value)}
            value={masterInvestorData &&( statusFlag=== COMPLIANCE_PENDING || statusFlag=== COMPLIANCE_APPROVED) ? masterInvestorData.home_country_contact: masterInvestorData && statusFlag=== COMPLIANCE_REJECTED ? rejectedInvDetails?.home_country_contact : indivInvFormData?.home_country_contact}
            disabled={statusFlag===COMPLIANCE_APPROVED}
        />
        <InputFieldKYC label={"Country of Birth"}
          mandatory={"*"}
          placeholder={"ex.Bahrain"}
          disabled={statusFlag===COMPLIANCE_APPROVED}
          onChange={(e) => handleFieldChange('country_of_birth', e.target.value)}
            value={masterInvestorData &&( statusFlag=== COMPLIANCE_PENDING || statusFlag=== COMPLIANCE_APPROVED) ? masterInvestorData.country_of_birth: masterInvestorData && statusFlag=== COMPLIANCE_REJECTED ? rejectedInvDetails?.country_of_birth : indivInvFormData?.country_of_birth}
        />
        <InputFieldKYC label={"Date of Birth"} type={"date"}
          mandatory={"*"}
          placeholder={""}
          disabled={statusFlag===COMPLIANCE_APPROVED}
          max={new Date().toISOString().split('T')[0]}
          onChange={(e) => handleFieldChange('date_of_birth', e.target.value)}
          value={
            masterInvestorData ?
                          (statusFlag=== COMPLIANCE_PENDING ||
                            statusFlag=== COMPLIANCE_APPROVED )
                            ? (masterInvestorData.date_of_birth? moment(masterInvestorData.date_of_birth).format(
                                "YYYY-MM-DD"
                              ):"")
                            : masterInvestorData && statusFlag === COMPLIANCE_REJECTED
                            ?(rejectedInvDetails?.date_of_birth ?  moment(rejectedInvDetails?.date_of_birth).format(
                                "YYYY-MM-DD"
                              ):"")
                            : 
                            moment(indivInvFormData?.date_of_birth).format(
                              "YYYY-MM-DD"
                            ):indivInvFormData && moment(indivInvFormData?.date_of_birth).format(
                              "YYYY-MM-DD"
                            )
          }
        />
      </div>

      <div className="row gap-lg-3 mt-2">
        <InputFieldKYC label={"Passport/ Government Issued ID"}
          placeholder={"Input ID number"}
          mandatory={"*"}
          htmlFor={"passport_no"}
          name={"passport_no"}
          disabled={statusFlag===COMPLIANCE_APPROVED}
          onChange={(e) => handleFieldChange('passport_number', e.target.value)}
            value={masterInvestorData &&( statusFlag=== COMPLIANCE_PENDING || statusFlag=== COMPLIANCE_APPROVED) ? masterInvestorData.passport_number: masterInvestorData && statusFlag=== COMPLIANCE_REJECTED ? rejectedInvDetails?.passport_number : indivInvFormData?.passport_number}   

        />
        <InputFieldKYC label={"ID Expiry Date"} type={"date"}
          placeholder={""}
          mandatory={"*"}
          htmlFor={"passport_expiry_date"}
          name={"passport_expiry_date"}
          min={new Date().toISOString().split('T')[0]}
          disabled={statusFlag===COMPLIANCE_APPROVED}
          onChange={(e) => handleFieldChange('passport_expiry_date', e.target.value)}
          value={
            masterInvestorData ?
                          (statusFlag === COMPLIANCE_PENDING ||
                            statusFlag === COMPLIANCE_APPROVED )
                            ? (masterInvestorData.passport_expiry_date ? moment(masterInvestorData.passport_expiry_date).format(
                                "YYYY-MM-DD"
                              ):"")
                            : masterInvestorData && statusFlag === COMPLIANCE_REJECTED
                            ?(rejectedInvDetails?.passport_expiry_date ?  moment(rejectedInvDetails?.passport_expiry_date).format(
                                "YYYY-MM-DD"
                              ):"")
                            : 
                            moment(indivInvFormData?.passport_expiry_date).format(
                              "YYYY-MM-DD"
                            ):indivInvFormData && moment(indivInvFormData?.passport_expiry_date).format(
                              "YYYY-MM-DD"
                            )
          }
        />
        <InputFieldKYC label={"Other Passport Details"}
          htmlFor={"other_passport_details"}
          name={"other_passport_details"}
          placeholder={"Other passport details incase Dual nationality"}
          disabled={statusFlag===COMPLIANCE_APPROVED}
          onChange={(e) => handleFieldChange('other_passport_details', e.target.value)}
            value={masterInvestorData &&( statusFlag=== COMPLIANCE_PENDING || statusFlag=== COMPLIANCE_APPROVED) ? masterInvestorData.other_passport_details: masterInvestorData && statusFlag=== COMPLIANCE_REJECTED ? rejectedInvDetails?.other_passport_details : indivInvFormData?.other_passport_details}   
        />

      </div>

      <div className="row gap-lg-3 mt-2">

        <InputFieldKYC label={"National ID"}
          placeholder={"ID number"}
          mandatory={"*"}
          htmlFor={"national_id"}
          name={"national_id"}
          disabled={statusFlag===COMPLIANCE_APPROVED}
          onChange={(e) => handleFieldChange('national_id', e.target.value)}
            value={masterInvestorData &&( statusFlag=== COMPLIANCE_PENDING || statusFlag=== COMPLIANCE_APPROVED) ? masterInvestorData.national_id: masterInvestorData && statusFlag=== COMPLIANCE_REJECTED ? rejectedInvDetails?.national_id : indivInvFormData?.national_id}   
        />

        <InputFieldKYC label={"Name of Employer or Business owned"}
          placeholder={"type here"}
          mandatory={"*"}
          name={"name_of_employer"}
          id={"name_of_employer"}
          disabled={statusFlag===COMPLIANCE_APPROVED}
          onChange={(e) => handleFieldChange('name_of_employer', e.target.value)}
            value={masterInvestorData &&( statusFlag=== COMPLIANCE_PENDING || statusFlag=== COMPLIANCE_APPROVED) ? masterInvestorData.name_of_employer: masterInvestorData && statusFlag=== COMPLIANCE_REJECTED ? rejectedInvDetails?.name_of_employer : indivInvFormData?.name_of_employer}   
        />
        <InputFieldKYC label={"Country of Business or Employer"}
          placeholder={"ex.Bahrain"}
          mandatory={"*"}
          name={"country_of_employer"}
          id={"country_of_employer"}
          disabled={statusFlag===COMPLIANCE_APPROVED}
          onChange={(e) => handleFieldChange('country_of_employer', e.target.value)}
            value={masterInvestorData &&( statusFlag=== COMPLIANCE_PENDING || statusFlag=== COMPLIANCE_APPROVED) ? masterInvestorData.country_of_employer: masterInvestorData && statusFlag=== COMPLIANCE_REJECTED ? rejectedInvDetails?.country_of_employer : indivInvFormData?.country_of_employer}   
        />
      </div>


      <div className="row gap-lg-3 mt-2">
        <InputFieldKYC label={"Source of income"}
          mandatory={"*"}
          htmlFor={"sourse_of_fund"}
          name={"sourse_of_fund"}
          id={"sourse_of_fund"}
            placeholder={ "Employed/Self-employed/Other. If Other, please elaborate."}
            disabled={statusFlag===COMPLIANCE_APPROVED}
          onChange={(e) => handleFieldChange('sourse_of_fund', e.target.value)}
            value={  masterInvestorData &&( statusFlag=== COMPLIANCE_PENDING || statusFlag=== COMPLIANCE_APPROVED) ? masterInvestorData.sourse_of_fund: masterInvestorData && statusFlag=== COMPLIANCE_REJECTED ? rejectedInvDetails?.sourse_of_fund :indivInvFormData?.sourse_of_fund}   
        />
        <InputFieldKYC label={"Committed Principal in USD"}
          mandatory={"*"}
          type={"number"}
          htmlFor={"committed_principal"}
          name={"committed_principal"}
          id={"committed_principal"}
          placeholder={"Input principal amount"}
          disabled={statusFlag===COMPLIANCE_APPROVED}
          onChange={(e) => handleFieldChange('committed_principal', e.target.value)}
            value={masterInvestorData &&( statusFlag=== COMPLIANCE_PENDING || statusFlag=== COMPLIANCE_APPROVED) ? masterInvestorData.committed_principal: masterInvestorData && statusFlag=== COMPLIANCE_REJECTED ? rejectedInvDetails?.committed_principal : indivInvFormData?.committed_principal}   
        />


      </div>
      <div className="row mt-5">
        <h6 className="text-primary fw-bolder">Purpose of and Nature of the Business:</h6>
        <InputFieldKYC
          name={"description_of_income"}
          mandatory={"*"}
          id={"description_of_income"}
          label={"Brief description of activity providing source of income"}
          placeholder={"Input description of activity"}
          disabled={statusFlag===COMPLIANCE_APPROVED}
          onChange={(e) => handleFieldChange('description_of_income', e.target.value)}
            value={masterInvestorData &&( statusFlag=== COMPLIANCE_PENDING || statusFlag=== COMPLIANCE_APPROVED) ? masterInvestorData.description_of_income: masterInvestorData && statusFlag=== COMPLIANCE_REJECTED ? rejectedInvDetails?.description_of_income : indivInvFormData?.description_of_income}   

        />
      </div>
      <div className="row mt-5">
        <h6 className=" mb-0 text-primary fw-bolder">Nominee Details <span style={{ color: "red" }}>*</span></h6>
        <TextAreaField
          placeholder={"Name, age, address and contact details of nominee. In case the nominee is minor, please mention Name, age, address and contact details of guardian of the nominee."}
          disabled={statusFlag===COMPLIANCE_APPROVED}
          onChange={(e) => handleFieldChange('nominee_details', e.target.value)}
            value={masterInvestorData &&( statusFlag=== COMPLIANCE_PENDING || statusFlag=== COMPLIANCE_APPROVED) ? masterInvestorData.nominee_details: masterInvestorData && statusFlag=== COMPLIANCE_REJECTED ? rejectedInvDetails?.nominee_details : indivInvFormData?.nominee_details}   
        />
      </div>



        {(getDocuments&& statusFlag==COMPLIANCE_REJECTED) || 
                   (masterInvestorData && statusFlag=== COMPLIANCE_PENDING )|| 
                   (statusFlag=== COMPLIANCE_APPROVED)||
                   (statusFlag=== COMPLIANCE_REJECTED) ?                 
        <div className=" border p-3 rounded mt-4">
                     {getDocuments?.kyc_documents?.length!==0 ? <h6>
                        Uploaded Documents </h6>: <h6>No documents uploaded</h6> }
          <div className="upload_cls col  ">
            {getDocuments?.kyc_documents?.map((doc, index) => {
              return (
                <tr key={index}>
                  <td >{doc.document_type == undefined ? '-' : doc.document_type}</td>
                  <td >
                    <div className="d-flex justify-content-evenly">
                      <div className='align-self-center' >
                        <a style={{ display: "table-cell" }} href={doc.document_url} target="_blank">
                          <img src="./images/eye.svg" alt="" /></a>
                      </div>
                    </div>
                  </td>
                </tr>
              )
            })}
          </div>
                    </div> :""}

      <div className="container ms-0 px-0 pt-4">
        <div className="form-group row">
          <label className="col-form-label col-md-4"><p style={{ fontSize: "14px" }}> Are you a politically exposed person<span style={{ color: "red" }}>*</span> </p></label>
          <div className="col-sm-6 custom-radio d-flex gap-5 align-items-center ">
            <div className="custom-control custom-radio custom-control-inline d-inline-flex">
              <input type="radio" id="yesRadio" name="Yes" className=" " checked={
                masterInvestorData &&
                  (statusFlag === COMPLIANCE_PENDING ||
                    statusFlag === COMPLIANCE_APPROVED)
                  ? masterInvestorData.is_pep === "Yes"
                  : masterInvestorData &&
                    statusFlag === COMPLIANCE_REJECTED
                    ? rejectedInvDetails?.is_pep === "Yes"
                    : indivInvFormData?.is_pep === "Yes"} onClick={(e) => handleFieldChange("is_pep", "Yes")} />
              <label className="mt-1 ms-1" for="yesRadio">Yes</label>
            </div>
            <div className="custom-control custom-radio custom-control-inline d-inline-flex">
              <input type="radio" id="noRadio" name="No" className=" " checked={masterInvestorData &&
                (statusFlag === COMPLIANCE_PENDING ||
                  statusFlag === COMPLIANCE_APPROVED)
                ? masterInvestorData.is_pep === "No"
                : masterInvestorData &&
                  statusFlag === COMPLIANCE_REJECTED
                  ? rejectedInvDetails?.is_pep === "No"
                  : indivInvFormData?.is_pep === "No"} onClick={(e) => handleFieldChange("is_pep", "No")} />
              <label className="mt-1 ms-1" for="noRadio">No</label>
            </div>
          </div>
        </div>
      </div>

       {investorDatauser?.kyc?.length===0 ||
       statusFlag===COMPLIANCE_REJECTED || statusFlag===COMPLIANCE_NEW?
        <div className="row mt-5">
          <h6>
            Upload Documents{" "}
          </h6>
          <p>
            Please upload any documents relevant to this loan,
            including any invoices, or other documents.{" "}
            <span style={{ color: "red" }}>
              {" "}
              (File size should be less than 5 MB *)
            </span>
          </p>

          <div className="upload_cls col  ">
            {
                        handleIsDataNull?
                (download.map((item, index) => {
                  return (
                    <div key={item.doc_type} className="row align-items-baseline">
                      <div className="col-lg-4 text-start mt-2 text-wrap ">
                        <article>
                          {item.doc_type}
                          {item.doc_type==="Others" && <span style={{ fontSize:"11px" }}>
                   {" "}
                   (Max 50 files *)
                 </span>}
                          {statusFlag !== COMPLIANCE_REJECTED && (
                            (!item.doc_type.includes('Resident Visa') &&
                              !item.doc_type.includes('Valid Tenancy contract for Office or utility bill within last 3 months') &&
                              !item.doc_type.includes('Valid Tenancy contract of the signatory as residence proof')) &&
                              !item.doc_type.includes('Others')
                              ? <span className="text-danger fs-5">*</span> : ""
                          )}
                        </article>

                      </div>
                      <div className="col-lg-2">
                        <label className="d-flex">
                          <img
                            src="./images/icons/plus_symbol.svg"
                            alt="UploadFile"
                          />
                          <span className="me-3 text-start">
                            {" "}
                            {!item.is_upload ? "Upload File" : " Uploaded"}
                          </span>
                          <input
                            className="custom-file-input"
                            type="file"
                            onChange={(e) => handleChange(e, item, index)}
                            ref={fileInputRef}
                            multiple={item.doc_type === "Others"}
                          />
                        </label>
                      </div>
                      <div className="col-lg-5 ">
                        {item.is_upload ?
                          <div>
                            {item.doc_type === "Others" ? (
                              <div style={{ height: "100px", overflowY: "auto" }}>
                                {others.map((doc) => (
                                  <span>
                                    <a
                                      style={{ cursor: "pointer" }}
                                    >
                                      <FaEye className="eye-color mt-1" data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Click to view image" onClick={(e) => handleChangeDownloadForOthers(e, doc, doc.name)} />
                                    </a>{" "}
                                    <span className="input_filname"

                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title={doc instanceof File ? doc.name : doc.document_type}
                                      style={{
                                        display: "inline-block",
                                        maxWidth: "300px",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {" "}
                                      {doc.name ? (doc.name.length > 50 ? doc.name.slice(0, 50) + "..." : doc.name) : doc.document_type}
                                    </span>
                                    <span
                                      onClick={() => handleDeleteClickOthers(doc)}
                                    >
                                      <TiDeleteOutline color="red" fontSize={25} className="Cpointer ms-2" style={{marginLeft:"10px"}}/>
                                    </span>
                                    <br />
                                  </span>

                                ))}
                              </div>
                            ) : (
                              <span>
                                <a
                                  style={{ display: "table-cell", cursor: "pointer" }}
                                >
                                  <FaEye className="eye-color mt-1" data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Click to view image" onClick={(e) => handleChangeDownload(e, item)} />
                                </a>{" "}
                                <span className="input_filname"

                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title={item.file_name}
                                >
                                  {" "}
                                        {item.file_name?.length > 50
                                          ? item.file_name.slice(0, 50) + "..."
                                          : item.file_name}
                                </span>
                                <span
                                  onClick={() => handleDeleteClick(item)}
                                         
                                >
                                      <TiDeleteOutline color="red" fontSize={25} className="Cpointer ms-2"/>
                                </span>
                              </span>
                            )}
                          </div> : (
                            ""
                          )}
                      </div>
                    </div>
                  );
                        })):
                        (mergedDownloads.map((item, index) => {
                    return (
                      <div key={item.doc_type} className="row align-items-baseline">
                        <div className="col-lg-4 text-start mt-2 text-wrap ">
                          <article>
                            {item.doc_type}
                            {item.doc_type==="Others" && <span style={{ fontSize:"11px" }}>
                   {" "}
                   (Max 50 files *)
                 </span>}
                            {statusFlag !== COMPLIANCE_REJECTED && (
                              (!item.doc_type.includes('Resident Visa') &&
                                !item.doc_type.includes('Valid Tenancy contract for Office or utility bill within last 3 months') &&
                                !item.doc_type.includes('Valid Tenancy contract of the signatory as residence proof') &&
                                !item.doc_type.includes('Others')
                              )
                                ? <span className="text-danger fs-5">*</span> : ""
                            )}
                          </article>

                        </div>
                        <div className="col-lg-2">
                          <label className="d-flex">
                            <img
                              src="./images/icons/plus_symbol.svg"
                              alt="UploadFile"
                            />
                            <span className="me-3 text-start">
                              {" "}
                              {!item.is_upload ? "Upload File" : " Uploaded"}            
                            </span>
                            <input
                              ref={fileInputRef}
                              className="custom-file-input"
                              type="file"
                              multiple={item.doc_type === "Others"}
                              onChange={(e) => handleChange(e, item, index)}
                              style={{ display: "none" }}
                            />
                          </label>
                        </div>
                        <div className="col-lg-5 ">
                          {item.is_upload ? (
                            <div>
                              {item.doc_type === "Others" ? (
                                <div style={{ height: "100px", overflowY: "auto" }}>
                                  {others.map((doc) => (
                                    <span>
                                      <a
                                        style={{ cursor: "pointer" }}
                                      >
                                        <FaEye className="eye-color mt-1"  data-bs-toggle="tooltip"
                                          data-bs-placement="top"
                                          title="Click to view image" onClick={(e) => handleChangeDownloadForOthers(e, doc, doc.name)} />
                                      </a>{" "}
                                      <span className="input_filname"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title={doc instanceof File ? doc.name : doc.document_type}
                                        style={{
                                          display: "inline-block",
                                          maxWidth: "300px",
                                          overflow: "hidden",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {" "}
                                        {doc.name ? (doc.name.length > 50 ? doc.name.slice(0, 50) + "..." : doc.name) : doc.document_type}
                                      </span>
                                      <span
                                        onClick={() => handleDeleteClickOthers(doc)}
                                      >
                                        <TiDeleteOutline color="red" fontSize={25} className="Cpointer ms-2" style={{ marginLeft: "10px" }} />
                                      </span>
                                      <br />
                                    </span>
                                  ))}
                                </div>
                              ) : (
                                <span>
                                  <a
                                    style={{ display: "table-cell", cursor: "pointer" }}
                                  >
                                    <FaEye className="eye-color mt-1" data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title="Click to view image" onClick={(e) => handleChangeDownload(e, item)} />
                                  </a>{" "}
                                  <span className="input_filname"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title={item.file_name}
                                  >
                                    {" "}
                                    {item.file_name.length > 50 ? item.file_name.slice(0, 50) + "..." : item.file_name}
                                  </span>
                                  <span
                                    onClick={() => handleDeleteClick(item)}
                                  >
                                    <TiDeleteOutline color="red" fontSize={25} className="Cpointer ms-2" />
                                  </span>
                                </span>
                              )}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    );
                  }))
            }
          </div>
        </div>:""
      }



      <div className="settingsSavebtn">
        <Button variant="secondary" onClick={handleSaveDraft}
         disabled={statusFlag === COMPLIANCE_PENDING || statusFlag === COMPLIANCE_APPROVED ||saveKYCBtn}
        >Save as draft</Button>

        {(investorDatauser?.kyc?.length===0 || statusFlag===COMPLIANCE_NEW|| masterInvestorData?.length===0) &&  
          <button
            disabled={saveKYCBtn}
            className="btn blue_btn "
            onClick={handleSubmit(handleSavechanges)}
          >
            Submit
          </button>}
          {statusFlag=== COMPLIANCE_REJECTED && 
          <button
            disabled={saveKYCBtn}
            className="btn blue_btn " onClick={handleSubmit(handleUpdateKyc)}>
            Update
          </button>}
      </div>



    </p>

  );
};




export const FaEyeIcon = () => {
  return (
      <FaEye color="#0d6efd" className="me-2 mb-1 Cpointer" fontSize={18}/>
  )
}